/* RESPONSIBLE TEAM: team-automation-foundations */
import AutomationFinAIAgentAttributesNewRoute from 'embercom/routes/apps/app/automation/fin-ai-agent/attributes/new';

export default AutomationFinAIAgentAttributesNewRoute;
